import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AccountingWebSocketContext } from './AccountingWebSocketContext';
import WebSocket from '../../../WebSocket/WebSocket';
import routes from '../../../../routes/routes.json';
import { useIsCompanyChanged } from '../../../../hooks';

const netSuiteRoutes = [
  routes.netSuiteVendorBills,
  routes.netSuiteVendors,
  routes.netSuiteJournalEntriesList,
];

const AccountingWebSocket = () => {
  const { pathname } = useLocation();
  const { dispatchMessage } = useContext(AccountingWebSocketContext);
  const [isActivated, setIsActivated] = useState(false);

  const companyId = useIsCompanyChanged();

  useEffect(() => {
    if (!isActivated && netSuiteRoutes.includes(pathname)) {
      setIsActivated(true);
    }
  }, [pathname, isActivated]);

  if (!isActivated) return null;

  return <WebSocket key={companyId} onMessage={dispatchMessage} variant='accounting' />;
};

export default AccountingWebSocket;
